import { u as i, l as T, a as v, _ as C, b as f, c as S, i as R, d as M, e as m, B as c, f as U } from "./__internal__/chunk-6d58b50d.js";
import { y as Ce, D as xe, Q as be, o as Te, P as ve, A as Re, T as Me, V as Ue, g as Ae, aN as Qe, aQ as we, aM as Ne, U as ke, k as Ee, a1 as Oe, aU as De, a2 as Ve, a5 as Ge, a9 as Le, a6 as Be, aa as ze, a8 as Fe, as as We, R as He, aT as Ke, S as Ze, aG as Je, at as Ye, aL as $e, x as qe, aD as Xe, ay as es, au as ss, az as ts, aC as rs, aF as os, aw as as, av as ns, aK as is, aH as us, aI as cs, aE as ps, aJ as ls, aA as ds, aB as ms, ax as fs, W as hs, X as ys, Z as gs, p as Ps, a4 as Ss, a7 as js, $ as Is, Y as _s, ae as Cs, aq as xs, af as bs, ag as Ts, aj as vs, ai as Rs, ap as Ms, ab as Us, ac as As, ad as Qs, ah as ws, al as Ns, an as ks, ao as Es, ak as Os, am as Ds, ar as Vs, aP as Gs, a3 as Ls, a0 as Bs, G as zs, O as Fs, h as Ws, H as Hs, F as Ks, m as Zs, n as Js, j as Ys, s as $s, r as qs, z as Xs, C as et, q as st, E as tt, v as rt, I as ot, M as at, L as nt, K as it, J as ut, t as ct, N as pt, aO as lt, aR as dt, aV as mt, w as ft, aS as ht } from "./__internal__/chunk-6d58b50d.js";
import j from "@mui/material/useMediaQuery";
import { useEffect as I, useCallback as P, useRef as b } from "react";
import "react-dom";
const D = () => i().useVerifyShippingAddressMutation(), V = () => i().useSubmitApplePayNonceMutation(), A = {
  xs: "@media screen and (max-width: 349px)",
  sm: "@media screen and (min-width: 350px) and (max-width: 499px)",
  md: "@media screen and (min-width: 500px) and (max-width: 699px)",
  lg: "@media screen and (min-width: 700px) and (max-width: 1023px)",
  xl: "@media screen and (min-width: 1024px) and (max-width: 1299px)",
  xxl: "@media screen and (min-width: 1300px)"
}, h = (e) => j(A[e]), G = () => j("@media screen and (max-width: 699px)"), L = () => j("@media screen and (min-width: 1024px)", {
  noSsr: !0
}), B = () => {
  const e = {
    xs: h("xs"),
    sm: h("sm"),
    md: h("md"),
    lg: h("lg"),
    xl: h("xl"),
    xxl: h("xxl")
  };
  return Object.keys(e).find(
    (s) => e[s]
  ) || "xxl";
}, z = () => i().useGetCoreOrderCartQuery(), x = {}, F = ({
  component: e,
  useInstead: s
}) => {
  I(() => {
    e in x || (x[e] = !0, T && console.log(
      `%cThe ${e} component has been marked for removal, please use the ${s} component instead.`,
      "color: orange"
    ));
  }, []);
}, W = (e) => i().useGetDesignQuery(e, { skip: !e }), Q = ({ colorId: e }) => i().useGetProductQuery(
  /**
   * The Project Service prefers to avoid typecasting if at all possible.
   * The RTKQuery `skip` param is an exception to this rule.
   * This query should not fire when the skip condition is true,
   * but without typecasting, we will see the following error:
   *
   * Type 'number | undefined' is not assignable to type 'number'.
   * Type 'undefined' is not assignable to type 'number'.
   *
   * Hopefully RTKQuery will handle the skip param types better in the future
   * so that we will be able to remove this typecast.
   */
  { colorIds: [e] },
  { skip: !e }
), H = ({ styleId: e }) => i().useGetProductByStyleIdQuery(
  /**
   * The Project Service prefers to avoid typecasting if at all possible.
   * The RTKQuery `skip` param is an exception to this rule.
   * This query should not fire when the skip condition is true,
   * but without typecasting, we will see the following error:
   *
   * Type 'number | undefined' is not assignable to type 'number'.
   * Type 'undefined' is not assignable to type 'number'.
   *
   * Hopefully RTKQuery will handle the skip param types better in the future
   * so that we will be able to remove this typecast.
   */
  { styleId: e },
  {
    selectFromResult: ({ data: t, ...a }) => {
      var o, n;
      return {
        ...a,
        region: (n = (o = t == null ? void 0 : t.variants) == null ? void 0 : o.find(
          (r) => r.style_id === e && r.status === "active"
        )) == null ? void 0 : n.region,
        styleId: e,
        variants: t == null ? void 0 : t.variants
      };
    },
    skip: !e
  }
), K = ({
  colorId: e,
  styleId: s
}) => i().useGetComplementsQuery({ colorId: e, styleId: s }, { skip: !s }), Z = ({ colorIds: e }) => i().useGetProductsQuery(
  { colorIds: e },
  { skip: e == null ? void 0 : e.some((t) => !t) }
), J = (e) => {
  var l, p, d;
  const { data: s } = Q({ colorId: (l = e == null ? void 0 : e.product) == null ? void 0 : l.colorId }), t = v();
  if (!e)
    return !1;
  const a = (p = e == null ? void 0 : e.design) == null ? void 0 : p.cid, o = a ? t[a] : void 0, n = !!(s != null && s.specialty), r = ((d = o == null ? void 0 : o.personalization) == null ? void 0 : d.length) === 1, u = e.sampleType === C.PLA_BLANKS_SAMPLE || e.sampleType === C.PLA_PRINTED_SAMPLE;
  return !n && !r && !u;
}, Y = () => {
  const e = i(), { projectId: s } = f(), [t] = e.usePostDistributedOrderUpdateMutation(), [a, o] = e.useUpdateProjectDistributedOrderMutation();
  return [P(
    ({
      numberOfAddresses: r,
      shippingType: u
    }) => {
      const p = {
        deliveryMode: {
          [S.BULK]: "single",
          [S.INDIVIDUAL]: "distributed"
        }[u],
        inprogress: !0
      };
      r && (p.addressNumber = `${r}`), t(p), a({
        numberOfAddresses: r,
        projectId: s,
        shippingType: u
      });
    },
    [s, t, a]
  ), o];
}, $ = (e, s) => {
  const t = b(!0);
  I(() => {
    t.current ? t.current = !1 : e();
  }, s);
};
function q() {
  return i().useGetFullQuoteMutation();
}
const X = (e) => i().useGetOrderSetPricingDetailsQuery(void 0, e), ee = (e) => i().useGetOrderSetTotalQuery(void 0, e), se = (e) => i().useGetPaymentTokenQuery(void 0, e), te = (e) => {
  const s = i(), t = f();
  return s.useGetProjectQuery(t.projectId, {
    selectFromResult: ({ data: a, ...o }) => {
      var n;
      return {
        ...o,
        data: (n = a == null ? void 0 : a.items) == null ? void 0 : n.find((r) => r.id && r.id === e)
      };
    },
    skip: !t.isSuccess || !t.projectId
  });
}, re = () => {
  const e = i(), s = f();
  return e.useGetProjectQuery(s.projectId, {
    selectFromResult: ({ data: t, ...a }) => ({
      ...a,
      data: t == null ? void 0 : t.items
    }),
    skip: !s.isSuccess || !s.projectId
  });
}, oe = () => {
  const e = i(), s = f(), [t, a] = e.useUpdateProjectItemMutation();
  return [P(
    (n, r) => t({
      projectId: s.projectId,
      projectItemId: n.projectItemId,
      projectItem: n.projectItem,
      syncStrategy: r
    }),
    [s.projectId, t]
  ), a];
}, ae = () => {
  const e = i(), s = f(), [t, a] = e.useCreateProjectItemMutation();
  return [P(
    (n, r) => t({ projectId: s.projectId, projectItem: n, syncStrategy: r }),
    [s.projectId, t]
  ), a];
}, ne = () => {
  const e = i(), s = f(), [t, a] = e.useUpdateProjectItemsMutation();
  return [P(
    (n, r) => t({
      projectId: s.projectId,
      updatedProjectItems: n,
      syncStrategy: r
    }),
    [s.projectId, t]
  ), a];
}, ie = () => {
  const e = i(), s = f(), [t, a] = e.useDeleteProjectItemsMutation();
  return [P(
    (n, r) => t({ projectId: s.projectId, projectItemIds: n, syncStrategy: r }),
    [s.projectId, t]
  ), a];
}, ue = (e) => i().useGetSurchargesQuery(e, { skip: !e });
function ce() {
  return i().useGetQuoteMutation();
}
const pe = () => i().useLazyValidateZipCodeQuery(), le = () => i().useLazyGetVoucherQuery(), de = (e, s, t) => {
  const a = b(!1);
  I(() => {
    a.current || s && (e(), a.current = !0);
  }, t);
}, w = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD"
}).format, me = (e) => {
  if (!R(e))
    throw new TypeError("value should be a string");
  const s = parseFloat(e);
  if (!M(s))
    throw new TypeError("unable to convert string to number");
  if ((e.includes(".") ? e.split(".")[1].length : 0) > 2)
    throw new Error("unable to format more than two decimal places");
  return w(s).toString();
}, fe = (e) => {
  if (!e)
    return !1;
  const s = e.map(
    (a) => {
      var o;
      return ((o = a == null ? void 0 : a.fulfillment) == null ? void 0 : o.priority) || m.STANDARD;
    }
  );
  return [...new Set(s)].length > 1;
}, he = (e) => e ? e.views.reduce(
  (s, t) => Math.max(s, t.colorCount || 0),
  0
) : 0, ye = (e, s = "total_price") => {
  const t = Object.values(e).map(({ [s]: o }) => o || 0).reduce((o, n) => o.plus(n), c(0));
  return c(t).toFixed(2);
}, ge = (e, s) => Object.keys(e).reduce((a, o) => {
  var l, p, d, y, g, _;
  let n = c(0);
  const r = s[o], u = e[o][0];
  return Object.keys(s).length > 0 && (((l = u.fulfillment) == null ? void 0 : l.priority) === m.RUSH && (r != null && r.rush_shipping) ? n = c((p = r == null ? void 0 : r.rush_shipping) == null ? void 0 : p.delivery_price) : ((d = u.fulfillment) == null ? void 0 : d.priority) === m.SUPERRUSH && (r != null && r.super_rush_shipping) ? n = c((y = r == null ? void 0 : r.super_rush_shipping) == null ? void 0 : y.delivery_price) : ((g = u.fulfillment) == null ? void 0 : g.priority) === m.STANDARD && (r != null && r.standard_shipping) && (n = c((_ = r == null ? void 0 : r.standard_shipping) == null ? void 0 : _.delivery_price))), a.plus(n);
}, c(0)), Pe = (e) => {
  const s = Object.values(e).reduce((t, a) => {
    const n = ((a == null ? void 0 : a.service_charges) || []).reduce((r, u) => (u.type === "reorder" && (r = r.plus(u.price)), r), c(0));
    return t.plus(n);
  }, c(0));
  return s.lte(0) ? s : c(0);
}, Se = (e, s) => {
  let t = 0;
  return Object.keys(e).map((a) => {
    var u, l, p, d, y, g;
    const o = s[a], n = e[a][0];
    let r = 0;
    Object.keys(s).length > 0 && (((u = n.fulfillment) == null ? void 0 : u.priority) === m.RUSH && (o != null && o.rush_shipping) ? r = ((l = o == null ? void 0 : o.rush_shipping) == null ? void 0 : l.turn_time) ?? 0 : ((p = n.fulfillment) == null ? void 0 : p.priority) === m.SUPERRUSH && (o != null && o.super_rush_shipping) ? r = ((d = o == null ? void 0 : o.super_rush_shipping) == null ? void 0 : d.turn_time) ?? 0 : ((y = n.fulfillment) == null ? void 0 : y.priority) === m.STANDARD && (o != null && o.standard_shipping) && (r = ((g = o == null ? void 0 : o.standard_shipping) == null ? void 0 : g.turn_time) ?? 0)), r > t && (t = r);
  }), t;
}, je = ({
  shippingType: e,
  subTotalPrice: s,
  totalDeliveryAmount: t,
  numberOfAddresses: a
}) => e === S.INDIVIDUAL ? c(a || 2).times(U.SHIPPING_FEE).add(s) : c(t).plus(s);
export {
  Ce as BULK_MINIMUM_QUANTITY,
  U as BULK_SPLIT_SHIP,
  xe as DesignsProvider,
  be as DiscountVoucherType,
  Te as PricingProvider,
  ve as ProjectContext,
  Re as ProjectServiceApiProvider,
  Me as TurnTime,
  Ue as VoucherType,
  Ae as apiProxyTarget,
  Qe as applyVoucher,
  we as calculateTotalDiscount,
  Ne as canQuoteCart,
  ke as decorateWithDeliveryPrices,
  Ee as designsContext,
  Oe as findColor,
  De as getAllUnsatisfiedCriteria,
  Ve as getHex,
  Ge as getItemsTotalQuantity,
  he as getMaxColorCount,
  Le as getSizeLabel,
  Be as getSizeQuantityString,
  ze as getSizingGroups,
  ye as getSummarySubTotals,
  je as getTotalCost,
  ge as getTotalDeliveryAmount,
  Fe as getTotalQuantity,
  Pe as getTotalReorderDiscount,
  Se as getTotalTurnTime,
  We as getUrlParam,
  He as groupByDesign,
  Ke as hasApplicableVoucher,
  Ze as hasFlatRatePrice,
  Je as hasKeys,
  Ye as hasUrlParam,
  $e as hasView,
  qe as invalidVoucherErrorMessage,
  Xe as isActiveColor,
  es as isActiveView,
  ss as isArray,
  ts as isColor,
  rs as isDictionary,
  os as isKey,
  fe as isMultipleDeliveryOptions,
  as as isNotANumber,
  M as isNumber,
  ns as isObject,
  is as isProduct,
  us as isProject,
  cs as isProjectItemWithProduct,
  ps as isPropertyKey,
  ls as isQuotable,
  ds as isRgb,
  R as isString,
  ms as isSwatchData,
  fs as isSymbol,
  A as mediaQueries,
  hs as parseSizesAndPrice,
  ys as parseUnitPrices,
  gs as pluck,
  Ps as pricingContext,
  Ss as reduceObject,
  js as sizeIsDisabled,
  Is as sumBy,
  _s as sumUnitPrices,
  me as toCurrency,
  Cs as transformComplementsResponse,
  xs as transformCreateItemRequest,
  bs as transformDesignResponse,
  Ts as transformDesignResponseMap,
  vs as transformProductResponse,
  Rs as transformProductsResponse,
  Ms as transformProjectItemRequest,
  Us as transformProjectItemResponse,
  As as transformProjectItemsResponse,
  Qs as transformProjectResponse,
  ws as transformQuoteColorCountRequest,
  Ns as transformQuoteValidationResponse,
  ks as transformSizeObjects,
  Es as transformSizes,
  Os as transformStyleResponse,
  Ds as transformSurchargesResponse,
  Vs as transformUpdateItemRequest,
  Gs as transformVoucherNumber,
  Ls as transformZipCodeValidationResponse,
  Bs as unique,
  i as useApiContext,
  V as useApplePaySubmitNonce,
  zs as useAssociateProject,
  h as useBreakpoint,
  B as useBreakpointName,
  Fs as useCanQuoteCart,
  K as useComplements,
  J as useComplementsAllowed,
  Ws as useConfigContext,
  Hs as useConvertProject,
  z as useCoreOrderCart,
  Ks as useCreateProject,
  ae as useCreateProjectItem,
  ie as useDeleteProjectItems,
  F as useDeprecationMessage,
  W as useDesign,
  Zs as useDesignHasSleeve,
  v as useDesigns,
  Js as useDesignsLoaded,
  L as useDesktopBreakpoint,
  Y as useDistributedOrder,
  $ as useEffectOnChange,
  de as useEffectOnce,
  Ys as useErrorContext,
  q as useFullQuote,
  $s as useGroupedPrice,
  qs as useItemizedPriceData,
  G as useMobileBreakpoint,
  Xs as useMultipleDesigns,
  et as useMultipleQuotes,
  X as useOrderSetPricingDetails,
  ee as useOrderSetTotal,
  se as usePaymentToken,
  st as usePricing,
  Q as useProduct,
  H as useProductRegion,
  Z as useProducts,
  tt as useProject,
  f as useProjectId,
  te as useProjectItem,
  re as useProjectItems,
  ce as useQuote,
  rt as useQuotedVouchers,
  ot as useSizeQuantities,
  ue as useSurcharges,
  at as useUpdateProjectConfig,
  nt as useUpdateProjectConfigTaxExemptionMutation,
  oe as useUpdateProjectItem,
  ne as useUpdateProjectItems,
  it as useUpdateVoucherCode,
  ut as useUpdateZipCode,
  pe as useValidateZipCode,
  D as useVerifyShippingAddress,
  le as useVoucherCode,
  ct as useWCIBMO,
  pt as useZipCode,
  lt as verifyVoucher,
  dt as voucherCannotBeAppliedError,
  mt as voucherDoesNotSupportMultiDesign,
  ft as voucherNotFoundErrorMessage,
  ht as voucherPartiallyAppliedMessage
};
//# sourceMappingURL=index.js.map
